<template>
    <div class="card">
        <div class="card-header p-0" id="headingLayerResources">
            <a
                class="btn btn-block text-left p-3"
                data-toggle="collapse"
                role="button"
                href="#collapseLayerResources"
                aria-expanded="false"
                aria-controls="collapseLayerResources">
                <h6 class="mb-0">{{ $t(`${modelTranslateID}.title`) }}</h6>
            </a>
        </div>

        <div id="collapseLayerResources"
            class="collapse"
            aria-labelledby="headingLayerResources"
            data-parent="">
            <div class="card-body">
                <div class="row">
                    <div class="order-2 order-sm-1 col-12 col-sm-7 col-lg-6" v-if="!readonlyForm">
                        <TableData
                            :simplified="true"
                            :showTitleData="false"
                            ref="tblResources"
                            tableWrapperClass="py-2 px-1"
                            :startLoad="startLoadResources"
                            :route="url.getResources"
                            :settings="table.settings"
                            :columns="table.columns"
                            :inlineFilters="table.filters"
                            :autoUpdateFilter="table.autoUpdateFilter"
                            :externalFilters="tblFilters"
                            :autoUpdateExternalFilter="table.autoUpdateExternalFilter"
                            :addParamsToUrl="table.addParamsToUrl"
                            :loadingMsg="table.loadingMsg"
                            :notFoundMsg="table.notFoundMsg"
                            :orderByTemplate="table.orderByTemplate"
                        >
                            <template v-slot:filters="{ tableFilters, search }">
                                <form autocomplete="false" @submit.prevent="search" @keyup.enter="search">
                                    <div class="row header">
                                        <div class="col-12">
                                            <HeaderList
                                                :title="null"
                                                v-model="tableFilters.q"
                                                headerClass="mb-3">
                                            </HeaderList>
                                        </div>
                                    </div>
                                </form>
                            </template>

                            <template v-slot:body="{row, index, remove}">
                                <td :class="table.columns[0].class">
                                    <ResourceItemList
                                        :value="row"
                                        :enableCrossResource="enableCrossresources"
                                        :readonlyForm="readonlyForm"
                                        @addResource="addResource(row, index, remove)"
                                        @addCrossResource="addCrossResource(row, index)"
                                    />
                                </td>
                            </template>
                        </TableData>
                    </div>
                    <div class="order-1 order-sm-2 col-12 col-sm-5 col-lg-6">
                        <div class="row">
                            <div class="col-12">
                                <h5 class="d-flex justify-content-between justify-content-md-start align-items-center">
                                    <span class="text-muted pr-md-4">{{ $t(`${modelTranslateID}.resources_title`) }}</span>
                                    <span class="badge badge-secondary badge-pill">{{form.resources.length}}</span>
                                </h5>
                                <div class="form-group city-form-group">
                                    <HelpSpan :helpText="`${modelTranslateID}.resources_layers`" v-if="!readonlyForm" />
                                    <small v-if="fnHasError('resources')" class="invalid-feedback d-block">{{ fnFirstError('resources') }}</small>
                                </div>
                                <draggable
                                    tag="div"
                                    v-model="form.resources"
                                    v-bind="dragOptions"
                                    draggable=".list-group-item"
                                    @start="onDragStart"
                                    @end="onDragEnd"
                                    name="resources"
                                    v-validate="{required: true, length: 1}"
                                >
                                    <transition-group
                                        v-validate=""
                                        tag="ul"
                                        class="p-0"
                                        type="transition"
                                        :name="!drag ? 'flip-list' : null"
                                    >
                                        <li
                                            class="list-group-item p-0 border-0 cursor-default"
                                            v-for="(element, idx) in form.resources"
                                            :key="element.id"
                                        >
                                            <ResourceItemSelected
                                                :value="element"
                                                :readonlyForm="readonlyForm"
                                                :pivotKey="pivotResources"
                                                @removeResource="removeResource(idx)"
                                            />
                                        </li>
                                    </transition-group>
                                </draggable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ElementMixin from '../mixins/ElementMixin';
import ResourcesMixin from '@/app/shared/mixins/BaseResourcesGestaoMixin';
import draggable from "vuedraggable";

export default {
    name: 'LayerResources',
    components: {
        draggable,
        HelpSpan: () => import(/* webpackChunkName: "help-span" */ '@/components/form/HelpSpan.vue'),
        TableData: () => import(/* webpackChunkName: "table-data" */ '@/app/shared/components/tables/DataTable'),
        HeaderList: () => import(/* webpackChunkName: "header-list" */ '@/app/shared/components/manage/ManageHeaderList'),
        ResourceItemList: () => import(/* webpackChunkName: "ogc-resourceitemlist" */ '@/app/shared/components/ogc/resource/ResourceItemList'),
        ResourceItemSelected: () => import(/* webpackChunkName: "ogc-resourceitemselected" */ '@/app/shared/components/ogc/resource/ResourceItemSelected'),
    },
    mixins: [
        ElementMixin,
        ResourcesMixin,
    ],
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        idSubPanel: {
            type: String,
            default: 'resources',
        },
        parentId: {
            type: [Number, String],
            default: null,
        },
        loadResources: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            pivotResources: 'resourcelayer',
            table: {
                addParamsToUrl: true,
                loadingMsg: 'global.table.loading',
                notFoundMsg: 'global.table.no-data',
                orderByTemplate: 'global.table.order-by-template',
                autoUpdateFilter: true,
                autoUpdateExternalFilter: false,
                settings: {},
                columns: [
                    {
                        label: 'Nome',
                        field:  'name',
                        class: '',
                        sortable: true,
                    },
                ],
                filters: {
                    q: '',
                },
            },
            queryParams: {
                filters: 'filter',
            },
        }
    },
    computed: {
    },
    methods: {
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler: function(value, oldValue){
                this.form.resources = value;
            }
        },
        loadResources: {
            immediate: true,
            handler: function(value, oldValue){
                if(value != oldValue) {
                    this.startLoadResources = value;
                }
            }
        },
    }
}
</script>

<style></style>